module.exports = __webpack_public_path__ + "img/Antrians.dcc33ae9.svg";